import { createSlice } from "@reduxjs/toolkit";
import {
  getFirstFlow,
  createFirstFlow,
  updateFirstFlow,
  deleteFirstFlow,
  clearLocalActiveFirstFlow
} from './actions';

const initialState = {
  firstFlow: { id: '', phone: '', email: '', prompt: '', updated_at: '' },
  loading: false
};

const slice = createSlice({
  name: 'firstFlows',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getFirstFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(getFirstFlow.fulfilled, (state, action) => {
        const { first_flow } = action.payload;
        const firstFlow = { ...state.firstFlow, ...first_flow };
        
        state.loading = false;
        state.firstFlow = firstFlow;
      })
      .addCase(getFirstFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createFirstFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(createFirstFlow.fulfilled, (state, action) => {
        const { first_flow } = action.payload;
        
        state.loading = false;
        state.firstFlow = first_flow;       
      })
      .addCase(createFirstFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateFirstFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateFirstFlow.fulfilled, (state, action) => {
        const { status, first_flow } = action.payload;
        const updatedFirstFlow = { ...state.firstFlow, ...first_flow };
        
        state.loading = false;
        if (status === 204) state.firstFlow = updatedFirstFlow;       
      })
      .addCase(updateFirstFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteFirstFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteFirstFlow.fulfilled, (state, action) => {
        const { status } = action.payload;
        
        state.loading = false;
        if (status === 204) state.firstFlow = initialState.firstFlow;       
      })
      .addCase(deleteFirstFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(clearLocalActiveFirstFlow, state => {
        state.firstFlow = initialState.firstFlow;
      })
  }
})

export default slice.reducer;